import { Component } from '@angular/core';

@Component({
  selector: 'app-generic-error-dialog',
  templateUrl: './generic-error-dialog.component.html',
  styleUrls: ['./generic-error-dialog.component.css']
})
export class GenericErrorDialogComponent {

}
